import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { useRouter } from '@/routing'
import { variantsCards } from '@/shared/constants/variants'
import { Text } from '@/shared/ui'
import { ArrowXAxisIcon } from '@/shared/icons/arrow-x-axis-icon'
import { IWorkgroupPreview } from '@/interfaces/workgroups'
import { MotionLink } from '@/shared/ui/link'
import style from './workgroup-card.module.scss'

interface MissionCardProps extends Omit<HTMLProps<HTMLUListElement>, 'title' | 'id' | 'name'>, IWorkgroupPreview {
  index: number
}

export const WorkgroupCard = forwardRef<HTMLUListElement, MissionCardProps>((props, ref) => {
  const { className, name, chief, slug, index } = props
  const router = useRouter()

  return (
    <MotionLink
      className={clsx(style.card, className)}
      href={slug ? `/workgroup/${slug}` : ''}
      key={index}
      variants={variantsCards}
      custom={index}
    >
      <div className={style.endWrapper}>
        {chief.image && (
          <div className={style.img}>
            <Image
              fill
              src={chief.image.url}
              alt={chief.name}
              style={{ objectFit: 'cover', objectPosition: 'center top' }}
            />
          </div>
        )}
        <Text className={style.desc} type="t1">
          {chief.name}
        </Text>
      </div>
      <div className={style.line}></div>
      <div className={style.startWrapper}>
        <Text className={style.title} type="t2">
          {name}
        </Text>
        <ArrowXAxisIcon direction="next" className={style.imgArrow} />
      </div>
    </MotionLink>
  )
})

WorkgroupCard.displayName = 'MemberCard'
